export const games = {
    CLASSIC : "NoLimit",
    TIMER: "TimeLimit",
    TURBO: "TurnLimit",
    TOURNAMENT: "Tournament"
}

export const ERROR_TOAST_ID = 'errorToast';